import { useEffect, useState } from 'react';
import { v4 } from 'uuid';
import { HEARTS_ANIMATION, HEARTS_ANIMATION_GROUP } from '../../common';
import { Heart } from './Heart';
import { Animation, Group, Parent } from './styles';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const HeartsAnimation = ({
  children,
  onClick,
  shouldAnimationRun,
  state
}) => {
  const [hearts, setHearts] = useState([]);
  useEffect(() => {
    if (!state || !shouldAnimationRun) {
      return undefined;
    }
    const angle = Math.random() * Math.PI * 2;
    const heartsGroup = {
      angle,
      id: v4(),
      length: 3
    };
    window.requestAnimationFrame(() => {
      setHearts(prevState => [...prevState, heartsGroup]);
    });
    const timeout = setTimeout(() => {
      window.requestAnimationFrame(() => {
        setHearts(() => []);
      });
    }, 1500);
    return () => {
      clearTimeout(timeout);
    };
  }, [state, shouldAnimationRun]);
  return /*#__PURE__*/_jsxs(Animation, {
    "data-testid": HEARTS_ANIMATION,
    onClick: onClick,
    children: [/*#__PURE__*/_jsx(Parent, {
      children: children
    }), hearts.map(group => /*#__PURE__*/_jsx(Group, {
      "data-testid": HEARTS_ANIMATION_GROUP,
      children: Array.from({
        length: group.length
      }, (value, index) => /*#__PURE__*/_jsx(Heart, {
        angle: group.angle,
        index: index
      }, index))
    }, group.id))]
  });
};
//# sourceMappingURL=HeartsAnimation.js.map